interface CheckIconProps {
  variant?: "circle" | "flat" | "success";
  dataTestId?: string;
}

export default function CheckIcon({
  dataTestId,
  variant = "circle",
}: CheckIconProps) {
  if (variant === "circle") {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={dataTestId}
      >
        <path
          d="M8.17 13.87L14.8675 7.1725L13.5375 5.8425L8.17 11.21L5.4625 8.5025L4.1325 9.8325L8.17 13.87ZM9.5 19C8.18583 19 6.95083 18.7506 5.795 18.2519C4.63917 17.7531 3.63375 17.0763 2.77875 16.2213C1.92375 15.3663 1.24688 14.3608 0.748125 13.205C0.249375 12.0492 0 10.8142 0 9.5C0 8.18583 0.249375 6.95083 0.748125 5.795C1.24688 4.63917 1.92375 3.63375 2.77875 2.77875C3.63375 1.92375 4.63917 1.24688 5.795 0.748125C6.95083 0.249375 8.18583 0 9.5 0C10.8142 0 12.0492 0.249375 13.205 0.748125C14.3608 1.24688 15.3663 1.92375 16.2213 2.77875C17.0763 3.63375 17.7531 4.63917 18.2519 5.795C18.7506 6.95083 19 8.18583 19 9.5C19 10.8142 18.7506 12.0492 18.2519 13.205C17.7531 14.3608 17.0763 15.3663 16.2213 16.2213C15.3663 17.0763 14.3608 17.7531 13.205 18.2519C12.0492 18.7506 10.8142 19 9.5 19Z"
          fill="currentColor"
        />
      </svg>
    );
  } else if (variant === "success") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={dataTestId}
      >
        <path
          d="M14.8908 0.700439C15.2791 0.300261 15.9137 0.300169 16.3019 0.700439C16.6836 1.09387 16.6835 1.72694 16.3019 2.12036L6.28925 12.4417C5.90099 12.8414 5.26612 12.8415 4.87811 12.4417L0.686707 8.11938H0.68573C0.304548 7.72592 0.305189 7.09372 0.686707 6.70044C1.07498 6.3002 1.70958 6.30011 2.09784 6.70044L5.58319 10.2932L14.8908 0.700439Z"
          fill="#18C07D"
          stroke="#18C07D"
          strokeWidth="0.8"
        />
      </svg>
    );
  } else {
    // flat variant
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        data-testid={dataTestId}
      >
        <path
          d="M11.5361 0.877675L11.5361 0.877691L4.91891 7.49486L2.46376 5.03969C2.46375 5.03968 2.46374 5.03967 2.46373 5.03966C2.16414 4.74002 1.67838 4.74007 1.37879 5.03966C1.07919 5.33926 1.07921 5.82499 1.37877 6.12459L1.37879 6.1246L4.37647 9.12228C4.67597 9.42179 5.16182 9.42188 5.46141 9.12228L5.2182 8.87907L5.46141 9.12228L12.621 1.96263L12.621 1.96262C12.9206 1.66302 12.9206 1.17729 12.621 0.877691C12.3214 0.578075 11.8357 0.578126 11.5361 0.877675Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.687904"
        />
      </svg>
    );
  }
}
